import React, { useState } from "react";
import * as S from "./styles";
import { cloneDeep } from "lodash";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

const BorderForSort = ({ handleSearch, initialValue }) => {
  const label = "A-Z";
  const list = [
    { id: 0, nome: "A-Z", sort: "ASC" },
    { id: 1, nome: "Z-A", sort: "DESC" },
    { id: 2, nome: "Primeiro Cadastro", sort: "DataASC" },
    { id: 3, nome: "Último Cadastro", sort: "DataDESC" },
  ];
  const [filtredValue, setFiltredValue] = useState(list[initialValue].nome);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(cloneDeep(list));

  const handleOpen = () => {
    setOpen(!open);
  };

  const selection = (item) => {
    handleSearch(item);
    setFiltredValue(item?.nome);
    setOpen(false);
  };

  function handleFilter(e) {
    const value = e.target.value;
    setFiltredValue(e.target.value);

    if (!value || value === null || value === "") {
      setItems(
        list?.map((item) => ({
          id: item?.id,
          nome: item?.nome,
        }))
      );
      handleSearch(null);
    } else {
      setItems(
        items?.filter(
          (item) => item?.nome.toUpperCase().indexOf(value.toUpperCase()) !== -1
        )
      );
    }

    if (e && e.target.value.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }

  return (
    <>
      <S.Wrapper>
        <S.Main>
          <S.Select onClick={handleOpen}>
            <div className="Entrada">
              <div>
                <S.InputSearch
                  placeholder={label}
                  onChange={(e) => handleFilter(e)}
                  value={filtredValue}
                />
              </div>
              <div>
                {open ? (
                  <IoChevronUp size="2rem" />
                ) : (
                  <IoChevronDown size="2rem" />
                )}
              </div>
            </div>
          </S.Select>
          {open && (
            <S.Options>
              {items?.map((item) => (
                <S.Option key={item.id} onClick={() => selection(item)}>
                  <S.Description>
                    <div className="hover">{item?.nome}</div>
                  </S.Description>
                </S.Option>
              ))}
            </S.Options>
          )}
        </S.Main>
      </S.Wrapper>
    </>
  );
};

export default BorderForSort;
